module.exports = require("@pb/kit-util-use-callback-with-ref");